// import { WrappedRoleDetailPage } from './lib/RoleDetail';
import { WrappedRoleDetailPage } from './lib/RoleDetail2';

export * from './lib/components';
export default WrappedRoleDetailPage;
